export default
{
	items: [
		{
			name: "communiceren",
			actions: [
				{
					name: "patientvragennaardromen",
					enabledForModelStates: [0],
					targetModelState: 1,
					scores: [
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "orientatievragenstellen",
					enabledForModelStates: [0],
					targetModelState: 1,
					scores: [
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 2
				},
				{
					name: "patientlatenslapen",
					enabledForModelStates: [0],
					targetModelState: 3,
					scores: [
						{
							forPatientState: 0,
							value: -2
						},
					],
					weight: 0
				},
				{
					name: "afrondenenkamerverlaten",
					enabledForModelStates: [1],
					targetModelState: 3,
					scores: [
						{
							forPatientState: 0,
							value: 1
						},
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 1
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: -2
						},
					],
					weight: 0
				}
			]
		},
		{
			name: "klok",
			actions: [
				{
					name: "klokweghalen",
					enabledForModelStates: [1, 2, 3],
					targetModelState: 0,
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 1
				},
				{
					name: "klokterugplaatsen",
					enabledForModelStates: [0],
					targetModelState: 3,
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "batterijvervangen",
					enabledForModelStates: [1],
					targetModelState: 3,
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "default",
					enabledForModelStates: [1],
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: -1
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "whiteboard",
			actions: [
				{
					name: "uitvegen",
					enabledForModelStates: [1, 2, 3, 4],
					targetModelState: 0,
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 1
				},
				{
					name: "invullen",
					enabledForModelStates: [0],
					targetModelState: 4,
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "vervangen",
					enabledForModelStates: [1, 2, 3, 4],
					targetModelState: 4,
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: -1
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "lamellen",
			actions: [
				{
					name: "lamellenopenen",
					enabledForModelStates: [0],
					targetModelState: 1,
					scores: [
						{
							forPatientState: 0,
							value: 0
						},
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 1
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: -2
						},
						{
							forPatientState: 1,
							value: -1
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "bril",
			actions: [
				{
					name: "brilaanreiken",
					enabledForModelStates: [1],
					scores: [
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 1
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: 0
						},
						{
							forPatientState: 1,
							value: 0
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "ontbijt",
			actions: [
				{
					name: "ontbijtenaantafel",
					enabledForModelStates: [1],
					scores: [
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 3
				},
				{
					name: "ontbijteninbed",
					enabledForModelStates: [1],
					scores: [
						{
							forPatientState: 1,
							value: 0
						}
					],
					weight: 1
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: 0
						},
						{
							forPatientState: 1,
							value: 0
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "infuus",
			actions: [
				{
					name: "infuuscontroleren",
					scores: [
						{
							forPatientState: 0,
							value: -2
						},
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 1
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: 0
						},
						{
							forPatientState: 1,
							value: 0
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "medicatietoedienen",
			actions: [
				{
					name: "kalmerendemedicatietoedienen",
					scores: [
						{
							forPatientState: 0,
							value: -2
						},
						{
							forPatientState: 1,
							value: 0
						}
					],
					weight: 2
				},
				{
					name: "medicatietoelichtenaanpatient",
					enabledForModelStates: [1],
					scores: [
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: 1
						},
						{
							forPatientState: 1,
							value: 1
						}
					],
					weight: 0
				}
			]
		},
		{
			name: "cad",
			actions: [
				{
					name: "cadcontroleren",
					scores: [
						{
							forPatientState: 0,
							value: -1
						},
						{
							forPatientState: 1,
							value: 2
						}
					],
					weight: 2
				},
				{
					name: "default",
					scores: [
						{
							forPatientState: 0,
							value: 0
						},
						{
							forPatientState: 1,
							value: 0
						}
					],
					weight: 0
				}
			]
		}
	],
	mobile: {
		options: [
			{
				name: "mobielecomputerdossier",
				actions: [
					{
						name: "dossierbekijken",
						scores: [
							{
								forPatientState: 0,
								value: -1
							},
							{
								forPatientState: 1,
								value: 1
							}
						],
						weight: 2
					},
					{
						name: "default",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 0
					}
				]
			},
			{
				name: "mobielecomputerglucose",
				actions: [
					{
						name: "glucosemetinguitvoeren",
						scores: [
							{
								forPatientState: 0,
								value: -2
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 1
					},
					{
						name: "default",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 0
					}
				]
			},
			{
				name: "mobielecomputerlab",
				actions: [
					{
						name: "labwaardencontroleren",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 2
					},
					{
						name: "default",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 0
					}
				]
			},
			{
				name: "mobielecomputerzaalarts",
				actions: [
					{
						name: "zaalartsbellen",
						scores: [
							{
								forPatientState: 0,
								value: -2
							},
							{
								forPatientState: 1,
								value: -1
							}
						],
						weight: 2
					},
					{
						name: "default",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 0
					}
				]
			},
			{
				name: "mobielecomputerdos",
				actions: [
					{
						name: "dosfomulierinvullen",
						scores: [
							{
								forPatientState: 0,
								value: -1
							},
							{
								forPatientState: 1,
								value: 2
							}
						],
						weight: 2
					},
					{
						name: "default",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 0
					}
				]
			},
			{
				name: "mobielecomputerha",
				actions: [
					{
						name: "bekijkenhuisartsendossier",
						scores: [
							{
								forPatientState: 0,
								value: -1
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 2
					},
					{
						name: "default",
						scores: [
							{
								forPatientState: 0,
								value: 0
							},
							{
								forPatientState: 1,
								value: 0
							}
						],
						weight: 0
					}
				]
			}
		]
	}
}
